import React from "react";
import { Image } from "../../../design-system";
import heroSvg from "../../../../assets/illustrations/hero-secion.svg";

const HeroBackground: React.FC = () => {
  return (
    <Image
      src={heroSvg}
      alt=""
      containerProps={{
        sx: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "auto",
          zIndex: 1,
        },
      }}
      imageStyle={{
        width: "100%",
        height: "auto",
        display: "block",
      }}
    />
  );
};

export default HeroBackground;
